import React from "react";
import "./Profile.css";
import profileImg from "../assets/images/profile.jpeg";

const Profile = () => {
  return (
    <section className="profile-section" id="about">
      <div className="profile-container">
        <div className="profile-photo-container">
          <div className="photo-wrapper">
            <img src={profileImg} alt="Geetha M R" className="profile-photo" />
            <div className="photo-decoration"></div>
          </div>
        </div>

        <div className="profile-content">
          <h1 className="profile-name">Geetha M R</h1>
          <h2 className="profile-title">Insurance Advisor</h2>

          <div className="about-section">
            <h3>About Me</h3>
            <p className="profile-bio">
              17 yrs experience in finance planning advisory & being an
              insurance advisor career involves helping individuals and
              businesses find suitable insurance (health, life, motors & SME) by
              assessing needs, recommending policies, and guiding them through
              purchases, offering flexibility, savings, helping people to
              protect from financial risk & losses.
            </p>
            <p>
              I have completed & certified from Kinder brother international
              training programme{" "}
            </p>
          </div>

          <div className="cta-buttons">
            {/* <a href="#quote" className="btn btn-primary">
              Get Free Quote
            </a> */}
            <a href="#contact" className="btn btn-primary">
              Contact Me
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
